/**
 * Pure: build payload for initial setup API from form data.
 * Single Responsibility: shape payload; no side effects.
 */

/**
 * @param {Object} organizationData
 * @param {string} organizationData.organizationName
 * @param {string} organizationData.industry
 * @param {string} organizationData.street
 * @param {string} organizationData.city
 * @param {string} organizationData.state
 * @param {string} organizationData.zipCode
 * @param {Object} adminData
 * @param {string} adminData.fullName
 * @param {string} [adminData.phoneNumber]
 * @returns {Object} Payload for initialSetup API
 */
export function buildInitialSetupPayload(organizationData, adminData) {
  return {
    user: {
      fullName: adminData.fullName,
      phoneNumber: adminData.phoneNumber || '',
    },
    organization: {
      name: organizationData.organizationName,
      organizationType: organizationData.industry,
      address: {
        street: organizationData.street,
        city: organizationData.city,
        state: organizationData.state,
        zipCode: organizationData.zipCode,
      },
    },
  };
}
